import { Modal } from "react-bootstrap";
import CommonButton from "../commonButton";
import withModal from "./index";


const ConfirmModalInner = ({
    onClose,
    message = "Are you sure you want to change the status?",
    onConfirm,
    confirmText = "Yes",
    cancelText = "No",
    icon = null
}) => {
    const handleConfirm = () => {
        if (onConfirm) onConfirm();
        onClose();
    };

    return (
        <>
            <Modal.Body className="text-center">
                {icon && (
                    <i className="mb-3 primary">
                        {icon}
                    </i>
                )}
                {message}
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <CommonButton variant="secondary" onClick={onClose} title={cancelText} />
                <CommonButton variant="primary" onClick={handleConfirm} title={confirmText} />
            </Modal.Footer>
        </>
    );
};

const ConfirmModal = withModal(ConfirmModalInner);
export default ConfirmModal;
